export const nl: Record<string, string> = {
  'Add': 'Toevoegen',
  'Add user to favorites': 'Gebruiker aan favorieten toevoegen',
  'All time': 'Gehele periode',
  'Around the point you selected': 'Rond het geselecteerde punt',
  'Around the visible map area': 'Rond het zichtbare kaartgebied',
  'Back to map': 'Terug naar de kaart',
  'Back to sign in': 'Terug naar inloggen',
  'Cancel manual location placement': 'Handmatige locatieplaatsing annuleren',
  'Community map': 'Gemeenschapskaart',
  'Connecting to your device’s location signal…': 'Verbinding maken met het locatiesignaal van je apparaat…',
  'Could not get your current location.': 'Je huidige locatie kon niet worden bepaald.',
  'Could not save this location. Please try again.': 'Deze locatie kon niet worden opgeslagen. Probeer het opnieuw.',
  'Create account': 'Account aanmaken',
  'Creating account…': 'Account aanmaken…',
  'Dark Mode': 'Donkere modus',
  'Enable location': 'Locatie inschakelen',
  'End': 'Einde',
  'Failed to get location': 'Locatie ophalen mislukt',
  'Failed to load application statistics.': 'Applicatiestatistieken laden mislukt.',
  'Failed to load map activity.': 'Kaartactiviteit laden mislukt.',
  'Failed to load statuses': 'Statussen laden mislukt',
  'Favorite person': 'Favoriete persoon',
  'Favorite user': 'Favoriete gebruiker',
  'Find a person in direct messages': 'Een persoon zoeken in privéberichten',
  'Find a person…': 'Een persoon zoeken…',
  'Getting location…': 'Locatie ophalen…',
  'Hide password': 'Wachtwoord verbergen',
  'Hide statuses': 'Statussen verbergen',
  'Home': 'Start',
  'Join the map': 'Doe mee op de kaart',
  'Last day': 'Afgelopen dag',
  'Last month': 'Afgelopen maand',
  'Last week': 'Afgelopen week',
  'Light Mode': 'Lichte modus',
  'Like': 'Vind ik leuk',
  'Liked': 'Leuk gevonden',
  'Live location sharing is active.': 'Het delen van je live locatie is actief.',
  'Load older messages': 'Oudere berichten laden',
  'Loading older messages…': 'Oudere berichten laden…',
  'Manual location is active.': 'Handmatige locatie is actief.',
  'Map friend': 'Kaartvriend',
  'My statuses': 'Mijn statussen',
  'Nearby person': 'Persoon in de buurt',
  'Nearby statuses': 'Statussen in de buurt',
  'New people': 'Nieuwe mensen',
  'No nearby stories in this area yet': 'Nog geen verhalen in dit gebied',
  'No statuses found': 'Geen statussen gevonden',
  'No stories shared yet': 'Nog geen verhalen gedeeld',
  'Place a manual location': 'Handmatig een locatie plaatsen',
  'Profile': 'Profiel',
  'Refresh map': 'Kaart vernieuwen',
  'Remove': 'Verwijderen',
  'Remove user from favorites': 'Gebruiker uit favorieten verwijderen',
  'Reply': 'Reageren',
  'Save': 'Opslaan',
  'Saved': 'Opgeslagen',
  'Saving…': 'Opslaan…',
  'Search all direct messages': 'Alle privéberichten doorzoeken',
  'Search all messages…': 'Alle berichten doorzoeken…',
  'Search failed': 'Zoeken mislukt',
  'Searching…': 'Zoeken…',
  'Selected avatar': 'Geselecteerde avatar',
  'Sending…': 'Verzenden…',
  'Set a manual location': 'Handmatig een locatie instellen',
  'Set here': 'Hier instellen',
  'Set my location here': 'Mijn locatie hier instellen',
  'Setting your location…': 'Je locatie instellen…',
  'Share Status': 'Status delen',
  'Shared from the map': 'Gedeeld vanaf de kaart',
  'Sharing…': 'Delen…',
  'Show password': 'Wachtwoord tonen',
  'Show status location on map': 'Statuslocatie op de kaart tonen',
  'Signing in…': 'Inloggen…',
  'Someone': 'Iemand',
  'Start a conversation': 'Een gesprek beginnen',
  'Status details': 'Statusdetails',
  'That status is no longer available.': 'Die status is niet meer beschikbaar.',
  'The map is not ready yet.': 'De kaart is nog niet klaar.',
  'Time span': 'Tijdsperiode',
  'Unable to get your location': 'Je locatie kan niet worden bepaald',
  'Unfavorite user': 'Gebruiker uit favorieten verwijderen',
  'Unknown User': 'Onbekende gebruiker',
  'Unlike': 'Vind-ik-leuk intrekken',
  'User details': 'Gebruikersdetails',
  'User information not available': 'Gebruikersinformatie niet beschikbaar',
  'View statuses': 'Statussen bekijken',
  'Waiting for a precise device location…': 'Wachten op een nauwkeurige apparaatlocatie…',
  'What should nearby people know?': 'Wat moeten mensen in de buurt weten?',
  'What’s happening around you?': 'Wat gebeurt er om je heen?',
  'What’s happening, and when?': 'Wat gebeurt er, en wanneer?',
  'What’s the vibe, and where?': 'Hoe is de sfeer, en waar?',
  'You': 'Jij',
  'Your location': 'Je locatie',
  'Your map location': 'Je locatie op de kaart',
  'Close menu': 'Menu sluiten',
  'Close notifications': 'Meldingen sluiten',
  'Close panel': 'Paneel sluiten',
  'Close search': 'Zoeken sluiten',
  'Close statistics': 'Statistieken sluiten',
  'Close status': 'Status sluiten',
  'Close user profile': 'Gebruikersprofiel sluiten',
  'Close user settings': 'Gebruikersinstellingen sluiten',
  'Dismiss error': 'Foutmelding verbergen',
  'Dismiss welcome message': 'Welkomstbericht verbergen',
  'Opening your map…': 'Je kaart openen…',
  'Checking your map identity…': 'Je kaartidentiteit controleren…',
  'Actions for this map point': 'Acties voor dit kaartpunt',
  'Avatar image URL': 'URL van avatarafbeelding',
  'Enter your display name': 'Voer je weergavenaam in',
  'Frame your avatar': 'Kader je avatar in',
  'From': 'Van',
  'Here · 50 m': 'Hier · 50 m',
  'How people will see you': 'Hoe mensen je zien',
  'JPEG, PNG, or GIF up to 5 MB.': 'JPEG, PNG of GIF tot 5 MB.',
  'Move the map until the target is over the right place.': 'Verplaats de kaart tot het doel op de juiste plek staat.',
  'mapbl version': 'mapbl-versie',
  'About': 'Over',
  'About mapbl': 'Over mapbl',
  'About the service': 'Over de dienst',
  'Account': 'Account',
  'All stories': 'Alle verhalen',
  'Application statistics': 'Applicatiestatistieken',
  'Area': 'Gebied',
  'Back to conversations': 'Terug naar gesprekken',
  'Bio': 'Biografie',
  'Cancel': 'Annuleren',
  'Choose your map position': 'Kies je positie op de kaart',
  'Choose your map vibe': 'Kies je kaartsfeer',
  'Clear': 'Wissen',
  'Community first': 'De gemeenschap voorop',
  'Connection interrupted': 'Verbinding onderbroken',
  'Could not locate you': 'Je locatie kon niet worden bepaald',
  'Create Status': 'Status maken',
  'Create an account': 'Een account aanmaken',
  'Create status': 'Status maken',
  'Create your identity': 'Maak je identiteit',
  'Crop Current Avatar': 'Huidige avatar bijsnijden',
  'Direct Messages': 'Privéberichten',
  'Direct messages': 'Privéberichten',
  'Display Name': 'Weergavenaam',
  'Display name': 'Weergavenaam',
  'Edit': 'Bewerken',
  'Edit direct message': 'Privébericht bewerken',
  'Edit reply': 'Reactie bewerken',
  'Edited': 'Bewerkt',
  'Email address': 'E-mailadres',
  'Emoji collections': 'Emojiverzamelingen',
  'Favorites': 'Favorieten',
  'Filter by status type': 'Filteren op statustype',
  'Finding your location': 'Je locatie zoeken',
  'Go to my location': 'Naar mijn locatie',
  'Ignore user': 'Gebruiker negeren',
  'Ignored users': 'Genegeerde gebruikers',
  'Jump to latest messages': 'Naar de nieuwste berichten',
  'Last 24 hours': 'Afgelopen 24 uur',
  'Last hour': 'Afgelopen uur',
  'Link (optional)': 'Link (optioneel)',
  'Live map stories': 'Live kaartverhalen',
  'Load more results': 'Meer resultaten laden',
  'Load older': 'Oudere laden',
  'Loading favorites…': 'Favorieten laden…',
  'Loading messages…': 'Berichten laden…',
  'Loading statuses': 'Statussen laden',
  'Loading user data...': 'Gebruikersgegevens laden…',
  'Loading…': 'Laden…',
  'Locating you': 'Je locatie bepalen',
  'Map': 'Kaart',
  'Map navigation': 'Kaartnavigatie',
  'Mark all read': 'Alles als gelezen markeren',
  'Message': 'Bericht',
  'Message *': 'Bericht *',
  'Messages': 'Berichten',
  'My Location': 'Mijn locatie',
  'My Statuses': 'Mijn statussen',
  'Nearby Statuses': 'Statussen in de buurt',
  'Nearby activity': 'Activiteit in de buurt',
  'Nearby radius': 'Zoekstraal',
  'New status': 'Nieuwe status',
  'No matching messages found.': 'Geen overeenkomende berichten gevonden.',
  'No notifications yet': 'Nog geen meldingen',
  'Notifications': 'Meldingen',
  'Notification settings': 'Meldingsinstellingen',
  'Number of statuses': 'Aantal statussen',
  'Open shared link': 'Gedeelde link openen',
  'Password': 'Wachtwoord',
  'People': 'Mensen',
  'People and statuses you saved': 'Opgeslagen mensen en statussen',
  'Posted': 'Geplaatst',
  'Privacy & play': 'Privacy en spel',
  'Privacy Policy': 'Privacybeleid',
  'Private conversation': 'Privégesprek',
  'Private conversations': 'Privégesprekken',
  'Profile settings': 'Profielinstellingen',
  'Ready to upload': 'Klaar om te uploaden',
  'Recent': 'Recent',
  'Recent searches': 'Recente zoekopdrachten',
  'Refresh': 'Vernieuwen',
  'Refresh statuses': 'Statussen vernieuwen',
  'Reload mapbl': 'mapbl opnieuw laden',
  'Reply to status': 'Reageren op status',
  'Search a wider area': 'In een groter gebied zoeken',
  'Selected map point': 'Geselecteerd kaartpunt',
  'Selected period': 'Geselecteerde periode',
  'Send direct message': 'Privébericht verzenden',
  'Settings': 'Instellingen',
  'Share nearby': 'Delen in de buurt',
  'Short bio': 'Korte biografie',
  'Show': 'Tonen',
  'Sign in': 'Inloggen',
  'Sign in to mapbl': 'Inloggen bij mapbl',
  'Start must be before end.': 'Het begin moet vóór het einde liggen.',
  'Status reply': 'Reactie op status',
  'Statuses': 'Statussen',
  'Stop ignoring': 'Niet meer negeren',
  'Surprise me': 'Verras me',
  'Surprise me with an emoji': 'Verras me met een emoji',
  'Time': 'Tijd',
  'Time filter': 'Tijdfilter',
  'Time span end': 'Einde van de tijdsperiode',
  'Time span start': 'Begin van de tijdsperiode',
  'To': 'Tot',
  'Toggle menu': 'Menu openen of sluiten',
  'Try again': 'Opnieuw proberen',
  'Unread': 'Ongelezen',
  'Updated': 'Bijgewerkt',
  'Use a photo': 'Een foto gebruiken',
  'Use an image URL instead': 'Een afbeeldings-URL gebruiken',
  'Use emoji': 'Emoji gebruiken',
  'Use this crop': 'Deze uitsnede gebruiken',
  'What are you sharing?': 'Wat deel je?',
  'Width': 'Breedte',
  'Write a direct message': 'Een privébericht schrijven',
  'Write a message…': 'Schrijf een bericht…',
  'Write a reply…': 'Schrijf een reactie…',
  'You are not ignoring anyone.': 'Je negeert niemand.',
  'Your map identity': 'Je kaartidentiteit',
  'Your password': 'Je wachtwoord',
  'Your recent posts and moments': 'Je recente berichten en momenten',
  'You’re on the map': 'Je staat op de kaart',
  'Zoom': 'Zoom',
  'edited': 'bewerkt',
  'latest': 'nieuwste',
  'optional': 'optioneel',
  'statuses': 'statussen',
  'sent you a message': 'heeft je een bericht gestuurd',
  'replied to your status': 'heeft op je status gereageerd',
  'Just now': 'Zojuist',
  'Statuses (': 'Statussen (',
  'Users (': 'Gebruikers (',
  'people ·': 'mensen ·',
  'Failed to update profile': 'Profiel bijwerken mislukt',
  'Failed to upload avatar': 'Avatar uploaden mislukt',
  'Failed to log out': 'Uitloggen mislukt',
  'Please select a valid image file (JPEG, PNG, GIF)': 'Selecteer een geldig afbeeldingsbestand (JPEG, PNG, GIF)',
  'File size must be less than 5MB': 'Het bestand moet kleiner zijn dan 5 MB',
  'Geolocation is not supported by this browser': 'Deze browser ondersteunt geen geolocatie',
  'Location permission denied': 'Locatietoegang geweigerd',
  'Location unavailable': 'Locatie niet beschikbaar',
  'A fantasy map made for fun': 'Een fantasiekaart voor de lol',
  'A little about you': 'Iets over jou',
  'Bright, friendly, and a little futuristic.': 'Vrolijk, vriendelijk en een beetje futuristisch.',
  'Tell us about yourself': 'Vertel iets over jezelf',
  'What other players can see': 'Wat andere spelers kunnen zien',
  'Your choices': 'Je keuzes',
  '5 seconds': '5 seconden',
  '10 seconds': '10 seconden',
  'A quick heads-up': 'Even ter informatie',
  'Recommended': 'Aanbevolen',
  'Never': 'Nooit',
  'Keep markers still': 'Markeringen stilhouden',
  'Until I open it': 'Tot ik het open',
  'Animate until selected': 'Animeren tot selectie',
  'Uploading…': 'Uploaden…',
  'Upload avatar': 'Avatar uploaden',
  'Logging out…': 'Uitloggen…',
  'Logout': 'Uitloggen',
  'Updating…': 'Bijwerken…',
  'Update Profile': 'Profiel bijwerken',
  'Language': 'Taal',
  'Interface language': 'Interfacetaal',
  'English': 'Engels',
  'Ukrainian': 'Oekraïens',
  'Spanish': 'Spaans',
  'French': 'Frans',
  'Norwegian': 'Noors',
  'Romanian': 'Roemeens',
  'Dutch': 'Nederlands',
  'Profile updated successfully!': 'Profiel bijgewerkt!',
  'Avatar uploaded successfully!': 'Avatar geüpload!',
  'Welcome back': 'Welkom terug',
  'New to mapbl?': 'Nieuw bij mapbl?',
  'Already on mapbl?': 'Al een account bij mapbl?',
  'Password is required': 'Wachtwoord is verplicht',
  'Email is required': 'E-mailadres is verplicht',
  'Enter a valid email address': 'Voer een geldig e-mailadres in',
  'At least 6 characters': 'Minimaal 6 tekens',
  'People and statuses could not be refreshed. Your current map view is still available.': 'Mensen en statussen konden niet worden vernieuwd. Je huidige kaartweergave is nog beschikbaar.',
  'Reconnecting people and nearby stories…': 'Opnieuw verbinden met mensen en verhalen in de buurt…',
  'Set your map location to make this status discoverable nearby.': 'Stel je kaartlocatie in zodat deze status in de buurt gevonden kan worden.',
  'The point you selected on the map will be attached to this status.': 'Het geselecteerde kaartpunt wordt aan deze status toegevoegd.',
  "This user hasn't posted any statuses yet": 'Deze gebruiker heeft nog geen statussen geplaatst',
  'Your current map location will be attached so nearby people can discover it.': 'Je huidige kaartlocatie wordt toegevoegd zodat mensen in de buurt je status kunnen vinden.',
  'Close about mapbl': 'Over mapbl sluiten',
  'Close cluster details': 'Clusterdetails sluiten',
  'Close create status dialog': 'Statusvenster sluiten',
  'Close details': 'Details sluiten',
  'Close direct messages': 'Privéberichten sluiten',
  'Close favorites': 'Favorieten sluiten',
  'Close map actions': 'Kaartacties sluiten',
  'Close map details': 'Kaartdetails sluiten',
  'Close statuses dialog': 'Statusoverzicht sluiten',
  'Dismiss about mapbl': 'Over mapbl verbergen',
  'Dismiss create status dialog': 'Statusvenster verbergen',
  'Dismiss map pulse': 'Kaartactiviteit verbergen',
  'Dismiss my statuses': 'Mijn statussen verbergen',
  'Dismiss nearby statuses': 'Statussen in de buurt verbergen',
  'Dismiss profile settings': 'Profielinstellingen verbergen',
  'Dismiss status error': 'Statusfout verbergen',
  'Avatar crop zoom': 'Zoom voor avataruitsnede',
  'Changes to this policy': 'Wijzigingen in dit beleid',
  'Effective September 7, 2026': 'Van kracht vanaf 7 september 2026',
  'How information is used': 'Hoe informatie wordt gebruikt',
  'Information used by the game': 'Informatie die het spel gebruikt',
  'Map content is not verified. Treat every status, identity, and location as fictional game content—not fact.': 'Kaartinhoud is niet geverifieerd. Beschouw elke status, identiteit en locatie als fictieve spelinhoud, niet als feiten.',
  'Maps and service providers': 'Kaarten en dienstverleners',
  'OpenStreetMap copyright and attribution': 'OpenStreetMap-auteursrecht en bronvermelding',
  'mapbl is a fantasy experience for fun.': 'mapbl is een fantasie-ervaring voor de lol.',
  'mapbl is a playful social map where you can share what is happening, discover nearby statuses, and see the community come alive around you.': 'mapbl is een speelse sociale kaart waarop je kunt delen wat er gebeurt, statussen in de buurt kunt ontdekken en de gemeenschap om je heen tot leven kunt zien komen.',
  'mapbl is a game and creative social experience. Names, profiles, locations, statuses, events, announcements, and other content shown on the map are user-submitted, are not independently verified, and must not be treated as statements of fact. Everything you see should be understood as fictional, role-play, or fantasy content created for entertainment only.': 'mapbl is een spel en een creatieve sociale ervaring. Namen, profielen, locaties, statussen, evenementen, aankondigingen en andere inhoud op de kaart worden door gebruikers ingediend, zijn niet onafhankelijk geverifieerd en mogen niet als feitelijke uitspraken worden beschouwd. Alles wat je ziet is fictie, rollenspel of fantasie, uitsluitend bedoeld voor vermaak.',
  'We process only the information needed to provide the experience: account details you submit, such as your email, display name, bio, avatar, and password in protected hashed form; statuses and reactions you create; a browser-selected or manually selected map location; and sign-in tokens stored on your device. This information is saved only so the game can operate and remember your account and game activity.': 'We verwerken alleen de informatie die nodig is om de ervaring te bieden: de accountgegevens die je indient, zoals je e-mailadres, weergavenaam, biografie, avatar en wachtwoord in beveiligde hashvorm; de statussen en reacties die je maakt; een door de browser of handmatig geselecteerde kaartlocatie; en inlogtokens op je apparaat. Deze informatie wordt alleen opgeslagen om het spel te laten werken en je account en spelactiviteit te onthouden.',
  'Submitted information is used only to authenticate you, display and personalize the map, show game content, support nearby discovery, and maintain the service. mapbl does not sell your personal information or use your game activity to make real-world claims about you.': 'Ingediende informatie wordt alleen gebruikt om je te authenticeren, de kaart weer te geven en te personaliseren, spelinhoud te tonen, ontdekkingen in de buurt mogelijk te maken en de dienst te onderhouden. mapbl verkoopt je persoonsgegevens niet en gebruikt je spelactiviteit niet om uitspraken over jou in de echte wereld te doen.',
  'The experience is built around a shared map. Your chosen game identity, avatar, bio, approximate or selected location, statuses, and reactions may be visible to other players. Your password and authentication tokens are not displayed to other players. Do not use real-world secrets, sensitive personal details, or a precise real-world location in your public game content.': 'De ervaring draait om een gedeelde kaart. Je gekozen spelidentiteit, avatar, biografie, geschatte of geselecteerde locatie, statussen en reacties kunnen zichtbaar zijn voor andere spelers. Je wachtwoord en authenticatietokens worden niet aan andere spelers getoond. Gebruik geen echte geheimen, gevoelige persoonsgegevens of een exacte locatie uit de echte wereld in je openbare spelinhoud.',
  'The site may rely on hosting, map, and geocoding providers to deliver the service. Those providers may receive ordinary technical requests, such as an IP address and map coordinates, under their own privacy terms. We limit access to stored information to what is necessary to operate and protect the game.': 'De site kan hosting-, kaart- en geocoderingproviders gebruiken om de dienst te leveren. Deze providers kunnen gewone technische verzoeken ontvangen, zoals een IP-adres en kaartcoördinaten, onder hun eigen privacyvoorwaarden. We beperken de toegang tot opgeslagen informatie tot wat nodig is om het spel te laten werken en te beschermen.',
  'You choose what identity, status, and location to submit. You can update your profile and game content through the available controls, stop sharing a browser location by changing your browser permissions, and sign out to remove sign-in tokens from the device. Please contact the site operator if you need help with your account or stored information.': 'Je kiest zelf welke identiteit, status en locatie je indient. Je kunt je profiel en spelinhoud bijwerken via de beschikbare bedieningselementen, het delen van je browserlocatie stoppen door je browsermachtigingen te wijzigen en uitloggen om inlogtokens van het apparaat te verwijderen. Neem contact op met de sitebeheerder als je hulp nodig hebt met je account of opgeslagen informatie.',
  'We may update this policy as the game changes. The effective date at the top will be revised when that happens. Continued use of mapbl after an update means you accept the revised policy.': 'We kunnen dit beleid bijwerken wanneer het spel verandert. De ingangsdatum bovenaan wordt dan aangepast. Als je mapbl na een update blijft gebruiken, accepteer je het herziene beleid.',
  'Favorite people or statuses to keep them close.': 'Voeg mensen of statussen toe aan je favorieten om ze bij de hand te houden.',
  'Filter profile statuses': 'Profielstatussen filteren',
  'Filter the signal': 'Het signaal filteren',
  'Live community signal': 'Liveactiviteit van de community',
  'Load older replies': 'Oudere reacties laden',
  'Loading ignored users…': 'Genegeerde gebruikers laden…',
  'Loading replies…': 'Reacties laden…',
  'Location needs attention': 'Locatie vereist aandacht',
  'Make it yours': 'Maak het persoonlijk',
  'Map avatar preview': 'Voorbeeld van kaartavatar',
  'Map discovery': 'Ontdekken op de kaart',
  'Map pulse': 'Kaartactiviteit',
  'Map refresh paused': 'Kaartvernieuwing gepauzeerd',
  'No people found in your direct messages.': 'Geen mensen gevonden in je privéberichten.',
  'Nothing shared in this cluster yet': 'Nog niets gedeeld in dit cluster',
  'Observe nearby statuses': 'Statussen in de buurt bekijken',
  'People make the map': 'Mensen maken de kaart',
  'Post a new status or message here': 'Plaats hier een nieuwe status of een bericht',
  'Reading the map pulse…': 'Kaartactiviteit ophalen…',
  'Refreshing the map': 'De kaart vernieuwen',
  'Replies and direct messages': 'Reacties en privéberichten',
  'Say hello to start the conversation.': 'Zeg hallo om het gesprek te beginnen.',
  'Search every message in your direct conversations.': 'Doorzoek alle berichten in je privégesprekken.',
  'Select a conversation to read your messages.': 'Selecteer een gesprek om je berichten te lezen.',
  'The map hit a rough patch': 'Er is een probleem met de kaart',
  'or set it manually on the map': 'of stel deze handmatig in op de kaart',
  'Failed to load current avatar image for cropping': 'De huidige avatar kon niet worden geladen om bij te snijden',
  'Geolocation is not supported by this browser.': 'Deze browser ondersteunt geen geolocatie.',
  'Location permission denied. Please enable location access in your browser settings.': 'Locatietoegang geweigerd. Schakel locatietoegang in via je browserinstellingen.',
  'Location request timed out. Please try again.': 'Het locatieverzoek is verlopen. Probeer het opnieuw.',
  'Location tracking failed': 'Locatie volgen mislukt',
  'Location tracking timed out': 'Locatie volgen duurde te lang',
  'Location unavailable. Please check your GPS or network connection.': 'Locatie niet beschikbaar. Controleer je GPS of netwerkverbinding.',
  'A quick look at how the community is moving.': 'Een snelle blik op de activiteit van de gemeenschap.',
  'Choose a photo or an upbeat emoji. This is how people recognize you on the map.': 'Kies een foto of een vrolijke emoji. Zo herkennen mensen je op de kaart.',
  'Choose how long new live locations and statuses animate on the map.': 'Kies hoelang nieuwe live-locaties en statussen op de kaart worden geanimeerd.',
  'Choose someone on the map to start a conversation.': 'Kies iemand op de kaart om een gesprek te beginnen.',
  'Drag to position, then fine-tune the zoom.': 'Sleep naar de juiste positie en pas daarna de zoom aan.',
  'Find the bright moments happening around you.': 'Ontdek de mooie momenten om je heen.',
  'Share a location, leave a status, and discover the people and energy nearby.': 'Deel een locatie, plaats een status en ontdek de mensen en energie in de buurt.',
  'Sign out of mapbl on this device.': 'Log uit bij mapbl op dit apparaat.',
  'Their locations, statuses, and direct messages are hidden both ways.': 'Locaties, statussen en privéberichten worden voor beide kanten verborgen.',
  'Your map, people, and nearby moments are waiting.': 'Je kaart, mensen en momenten in de buurt wachten op je.',
  'Your account and map data are safe. Reload mapbl to reconnect and pick up where you left off.': 'Je account en kaartgegevens zijn veilig. Laad mapbl opnieuw om verbinding te maken en verder te gaan waar je gebleven was.',
};
